"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.CommonErrorBoundary = void 0;

var _commonErrorBoundary = _interopRequireDefault(require("./components/common-error-boundary"));

exports.CommonErrorBoundary = _commonErrorBoundary["default"];